import { loadingImageList, preloadImages } from '../../../../commons/utils/imagePreloader';

async function initApp() {
    this.startInitProgress();
    const location = window.location;
    const urlSearchParams = new URLSearchParams(location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    this.page = { path: location.pathname, params };
    this.settings = { ...params };

    await this.getClientInfo(params);
    await this.getCountryInfo();
    preloadImages(loadingImageList());

    if (this.page.path.indexOf('/login') === -1) {
        await this.initDashboard();
    } else {
        this.initLogin();
    }

    this.stopInitProgress();
}

export default initApp;
